import { helpers } from 'vuelidate/lib/validators';

export const validDecimalPrecision = (maxDecimals) => (value) => {
    if (!helpers.req(value)) {
        return true;
    }

    const parts = value.toString().split('.');
    if (parts.length === 1) {
        return true;
    }

    if (parts.length > 2) {
        return false;
    }

    const decimalPart = parts[1];

    if (decimalPart.length > maxDecimals) {
        return false;
    }

    return true;
};
